import { Injectable } from "@angular/core";

import { Observable } from "rxjs";
import { map, shareReplay } from "rxjs/operators";

import { InstallationHttpClient, ParametreForAktuelleInstallation, UmbracoHttpClient } from "@e-forsyning/common/http";

import { PrognoseIndstillinger } from "../model/prognose-indstillinger.model";
import { PrognoseDto } from "../model/prognose.dto";
import { Prognose } from "../model/prognose.model";
import { PrognoseMapper } from "./prognose.mapper";

@Injectable({ providedIn: "root" })
export class PrognoseRepository {
    constructor(
        private readonly umbracoHttpClient: UmbracoHttpClient,
        private readonly installationHttpClient: InstallationHttpClient,
        private readonly mapper: PrognoseMapper
    ) {}

    public hentPrognose(forbrugstype: string): Observable<Prognose> {
        const aktivnr = this.installationHttpClient.credentials.aktivNr;
        return this.installationHttpClient
            .post<PrognoseDto>(
                "api/getberegnregnskab",
                { aktivnr, beregnetVarmeRegnskab: forbrugstype },
                ParametreForAktuelleInstallation.true
            )
            .pipe(
                map((result) => this.mapper.dtoToPrognose(result)),
                shareReplay(1)
            );
    }

    public hentIndstillinger(): Observable<PrognoseIndstillinger> {
        return this.umbracoHttpClient.hentSideData("beregnet-varmeregnskab").pipe(
            map((result) => ({
                sideTitel: result.menuTekst,
                sideUndertitel: result.topOverskrift,
                sideTekst: result.topIndhold,
                forbrugstype: result.beregnetVarmeregnskab === "Faktisk forbrug" ? "faktisk" : "budgetteret"
            })),
            shareReplay(1)
        );
    }
}
